import { render, staticRenderFns } from "./VisitorPersonalFormBlock.vue?vue&type=template&id=35b6dbe5"
import script from "./VisitorPersonalFormBlock.vue?vue&type=script&lang=js"
export * from "./VisitorPersonalFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports